import styled from 'styled-components';

export const SwitchContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const SwitchListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SwitchLabel = styled.label`
  margin-bottom: 24px;
`;
